export default __webpack_public_path__ + "static/media/pCWS-BNB.59781b07.svg";